// extracted by mini-css-extract-plugin
export var hotspotDrawerContainer = "HotspotDrawer-module--hotspotDrawerContainer--213N7";
export var drawerClosed = "HotspotDrawer-module--drawerClosed--13L5f";
export var drawerTitle = "HotspotDrawer-module--drawerTitle--33JlV";
export var arrowIcon = "HotspotDrawer-module--arrowIcon--mGYyA";
export var drawerGrid = "HotspotDrawer-module--drawerGrid--HPXA5";
export var drawerItem = "HotspotDrawer-module--drawerItem--3TAgn";
export var mapItem = "HotspotDrawer-module--mapItem--3Zl3i";
export var thumb = "HotspotDrawer-module--thumb--2yJ7E";